const t = "titlePage_9bkKw", e = "titlePage__text_JAdyk", a = {
  titlePage: t,
  titlePage__text: e
};
export {
  a as default,
  t as titlePage,
  e as titlePage__text
};
//# sourceMappingURL=titlePage.module.scss.js.map
